module.exports = __webpack_public_path__ + "img/logo2.29d09202.png";